import React from 'react';
import ProjectsData from '../../components/projectsData';
const Projects = () => {

  return (
    <ul className="project__container" id="projects">
      <ProjectsData />
    </ul>
  );
};
export default Projects;
